import type { KeyboardEventHandler, MouseEventHandler, ReactNode } from 'react';
import { Card } from 'react-bootstrap';
import classNames from 'classnames';
import Background from '@/components/common/Background';
import corner1 from '@/assets/img/icons/spot-illustrations/corner-1.png';
import corner2 from '@/assets/img/icons/spot-illustrations/corner-2.png';
import corner3 from '@/assets/img/icons/spot-illustrations/corner-3.png';
import corner4 from '@/assets/img/icons/spot-illustrations/corner-4.png';
import corner5 from '@/assets/img/icons/spot-illustrations/corner-5.png';

const CORNER_IMAGES = [corner1, corner2, corner3, corner4, corner5];

export type IndexerKpiTone =
  | 'neutral'
  | 'success'
  | 'danger'
  | 'warning'
  | 'primary';

/** Stat card with Falcon corner illustration background (same as TrackerAi KpiStatCard). */
export function IndexerKpiCard({
  tone = 'neutral',
  imageIndex = 0,
  className,
  children,
  role,
  tabIndex,
  onClick,
  onKeyDown,
}: {
  tone?: IndexerKpiTone;
  imageIndex?: number;
  className?: string;
  children: ReactNode;
  role?: string;
  tabIndex?: number;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
}) {
  const image = CORNER_IMAGES[imageIndex % CORNER_IMAGES.length];

  return (
    <Card
      className={classNames(
        'overview-kpi-card overflow-hidden',
        `overview-kpi-card--${tone}`,
        className,
      )}
      role={role}
      tabIndex={tabIndex}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <Background image={image} className="bg-card" />
      <Card.Body className="position-relative">{children}</Card.Body>
    </Card>
  );
}
